import { dxtToLocalServerTime } from "@dexteel/mesf-core";

import { MenuOptionType } from "@dexteel/mesf-core";
import { CallSplit, Comment } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import Edit from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import { useState } from "react";
import { DelayByShift } from "../models/DelayByShift";

type Props = {
	setSelectedData: (delay: DelayByShift) => void;
	setShowModal: (
		show: "new" | "edit" | "delete" | "justify" | "split" | "",
	) => void;
	updateUrl: (newAction?: string | null, newDelayId?: string | null) => void;
	writesLocked: boolean;
};

export const useDelaysOptionFunctions = ({
	setSelectedData,
	setShowModal,
	updateUrl,
	writesLocked,
}: Props) => {
	const [messageDeleteModal, setMessageDeleteModal] = useState("");

	// Create
	const createData = () => {
		if (updateUrl) {
			updateUrl("new", null);
		} else {
			setShowModal("new");
		}
	};

	// Edit
	const editData = (data: DelayByShift) => {
		updateUrl("edit", data.DelayId?.toString());
		setSelectedData(data);
	};

	// Justify
	const justifyData = (data: DelayByShift) => {
		updateUrl("justify", data.DelayId?.toString());
		setSelectedData(data);
	};

	// Split
	const splitData = (data: DelayByShift) => {
		updateUrl("split", data.DelayId?.toString());
		setSelectedData(data);
	};

	// Delete
	const deleteData = (data: DelayByShift) => {
		updateUrl("delete", data.DelayId?.toString());
		setSelectedData(data);
		const dateOpen = dxtToLocalServerTime(data.Start, "HH:mm:ss");
		setMessageDeleteModal(
			`The delay at ${dateOpen} will be deleted. Do you want to continue?`,
		);
	};

	// Get Menu options
	const getMenuOptions = (data: DelayByShift) => {
		let options: MenuOptionType[] = [];

		if (data) {
			options = options.concat([
				{
					name: "Justify Delay",
					key: "justify_delay",
					onClick: () => justifyData(data),
					icon: <Comment />,
				},
				{
					name: "Edit Delay",
					key: "edit_delay",
					onClick: () => editData(data),
					icon: <Edit />,
					disabled: !data.IsDelayManual,
				},
				{
					name: "Delete Delay",
					key: "delete_delay",
					onClick: () => deleteData(data),
					icon: <DeleteIcon />,
					disabled: !data.IsDelayManual || writesLocked,
				},
			]);

			options.push({
				name: "Split Delay",
				key: "split_delay",
				onClick: () => splitData(data),
				icon: <CallSplit />,
			});
		}
		options.push({
			name: "New Delay",
			key: "create_new_delay",
			onClick: () => createData(),
			icon: <PlaylistAddIcon />,
			disabled: writesLocked,
		});

		return options;
	};

	return {
		createData,
		justifyData,
		splitData,
		getMenuOptions,
		messageDeleteModal,
		setMessageDeleteModal,
	};
};
